import { h } from "preact";

import RawColor from "../../../foundation/api/model/colors/RawColor";
import Color from "../../../foundation/model/color";
import classname from "../../../foundation/utils/classname";

import { getMarkerCSSVariableForApiColor } from "../../../foundation/utils/color";
import { colorEquals } from "../../../foundation/utils/layer/color";
import ColorDot from "../ColorDot";

import styles from "./ColorSelector.module.css";

interface Props {
    class?: string;
    colors: Color[];
    selectedColor?: RawColor | null;
    withBorder?: boolean;
    onSelect: (color: RawColor) => void;
}

export default function ColorSelector({
    class: cssClass,
    colors,
    selectedColor,
    withBorder = false,
    onSelect
}: Props) {
    function handleColorSelect(index: number) {
        return () => {
            const { r, g, b, a } = colors[index];
            onSelect({ r, g, b, a });
        };
    }

    return (
        <div class={classname(styles.colorDotSelector, cssClass)}>
            {
                colors.map((color: Color, index: number) => (
                    <ColorDot
                        key={color}
                        color={getMarkerCSSVariableForApiColor(color) ?? color.toRGBAString()}
                        selected={
                            selectedColor
                                ? colorEquals(selectedColor, color)
                                : undefined
                        }
                        withBorder={withBorder}
                        onClick={handleColorSelect(index)}/>
                ))
            }
        </div>
    );
}
